import { ImportSupplyPointHeader } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { COMMON_FORM_FIELDS_TRANSLATED } from '../form';
import { APP_DICTIONARY } from '../root';

export const IMPORT_SUPPLY_POINT_HEADER_TRANSLATED = defineMessages<ImportSupplyPointHeader>({
  [ImportSupplyPointHeader.BillingPeriod]: {
    id: `app.establishments.supplyPoints.panelImport.fields.billingPeriod`,
  },
  [ImportSupplyPointHeader.Code]: {
    id: `app.establishments.supplyPoints.panelImport.fields.code`,
  },
  [ImportSupplyPointHeader.Contract]: {
    id: `app.establishments.supplyPoints.panelImport.fields.contract`,
  },
  [ImportSupplyPointHeader.DistributorCN]: {
    id: `app.establishments.supplyPoints.panelImport.fields.distributorCN`,
  },
  [ImportSupplyPointHeader.EstablishmentCode]: {
    id: `app.establishments.supplyPoints.panelImport.fields.establishmentCode`,
  },
  [ImportSupplyPointHeader.RegistrationNumber]: {
    id: `app.establishments.supplyPoints.panelImport.fields.registrationNumber`,
  },
  [ImportSupplyPointHeader.SupplierCN]: {
    id: `app.establishments.supplyPoints.panelImport.fields.supplierCN`,
  },
  [ImportSupplyPointHeader.Commodity]: {
    id: `app.establishments.supplyPoints.panelImport.fields.commodity`,
  },
  [ImportSupplyPointHeader.Name]: {
    id: `app.establishments.supplyPoints.panelImport.fields.name`,
  },
  [ImportSupplyPointHeader.Category]: APP_DICTIONARY.category,
  [ImportSupplyPointHeader.FlowType]: APP_DICTIONARY.flowType,
  [ImportSupplyPointHeader.Note]: COMMON_FORM_FIELDS_TRANSLATED.note,
  [ImportSupplyPointHeader.Attachments]: COMMON_FORM_FIELDS_TRANSLATED.attachments,
});
